// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__VSbJk","container":"style_container__2XDUY","footerNav":"style_footerNav__19UjN"};